import { render, staticRenderFns } from "./TradeRequestListsOfResponsesPerItem.vue?vue&type=template&id=824835c2"
import script from "./TradeRequestListsOfResponsesPerItem.vue?vue&type=script&lang=js"
export * from "./TradeRequestListsOfResponsesPerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports